<template>
  <v-container fluid>
    <!-- Migas de pan -->
    <v-breadcrumbs class="pa-1 ma-1" :items="breadcrumbs" />
    <!-- Tarjeta de búsqueda -->
    <v-card outlined class="m-4">
      <v-card-title class="text-h6 font-weight-medium">
        <v-icon left color="primary" class="mr-2">mdi-magnify</v-icon>
        Búsqueda de urgencia
      </v-card-title>
      <v-card-subtitle class="mb-4">
        Ingresa el <strong>FOLIO</strong> para actualizar los datos de la urgencia.
      </v-card-subtitle>
      <v-card-text>
        <v-form @submit.prevent="Buscar">
          <v-row dense>
            <!-- Campo de búsqueda -->
            <v-col cols="12" sm="6" md="4" lg="4">
              <v-text-field v-model="search" label="Escribe aquí" v-mask="'UR-AAA-###'" outlined dense clearable
                class="col" prepend-inner-icon="mdi-magnify" @keyup.enter="Buscar"
                  @input="search = toUpperCaseGeneral(search)" />
            </v-col>

            <v-col>
              <v-btn color="azulfuerte" @click="Buscar" outlined dark
              >
              {{ loading ? 'Buscando...' : 'Buscar' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-card v-if="urgencia?.Estado" outlined class="pa-4 elevation-5">
          <!-- Estatus -->
          <v-row no-guters justify="end">
            <v-chip :color="urgencia.Estado === '0' ? 'green darken-2' : 'red darken-2'" text-color="white"
              class="text-subtitle-1 px-4 py-2">
              <v-icon left small>
                {{ urgencia.Estado === '0' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
              </v-icon>
              {{ urgencia.Estado === '0' ? 'ABIERTA' : 'CERRADA' }}
            </v-chip>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <!-- Folio y titular -->
              <v-card-title class="mb-1">
                <!-- <v-icon left class="mr-2">mdi-account</v-icon> -->
                Folio: {{ urgencia.Folio }}
              </v-card-title>

              <v-card-subtitle class="mb-2 grey--text text--darken-1">
                Membresía: {{ urgencia.IdContrato }}<br />
                Titular: <b>{{ urgencia.Titular }}</b>
              </v-card-subtitle>
              <!-- Paciente -->
              <div class="mb-2 d-flex align-center">
                <v-icon left small class="mr-1">mdi-file-document-outline</v-icon>
                <strong>Paciente:</strong>&nbsp;{{ urgencia.Paciente }}
              </div>

              <!-- Monto -->
              <!-- <div class="mb-3 d-flex align-center">
                <v-icon left small class="mr-1">mdi-hospital</v-icon>
                <strong>Monto urgencias:</strong>&nbsp;
                <span class="font-weight-bold">{{ urgencia.MontoDisponible }}</span>
              </div> -->
            </v-col>
            <v-col cols="12" md="8">
              Ingresa los datos de urgencia
              <!-- Formulario de cierre -->
              <v-form :disabled="urgencia.Estado === '1'" ref="formUrgencia">
                <v-row>
                  <v-col cols="12">
                    <v-radio-group dense v-model="DetalleUrgencia.Tipo" :rules="[v => !!v || 'Selecciona una opción']"
                      row>
                      <v-radio label="¿Fue un accidente?" value="2" />
                      <v-radio label="¿Fue una enfermedad?" value="1" />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Diagnóstico" v-model="DetalleUrgencia.Diagnostico" outlined dense clearable
                      :rules="[rules.ruleRequired]" />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Factura / Folio hospital" v-model="DetalleUrgencia.Factura" outlined dense
                      clearable />
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <v-expansion-panels focusable flat>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          💡¿Que hacer si el total sobrepasa el limite de cobertura del paciente?
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          Se factura el monto maximo a Medicover y la <strong>diferencia</strong> se cobra al paciente.
                          <!-- Para actualizar tus datos, ve a <strong>Mi cuenta</strong> → <strong>Perfil</strong> → <strong>Editar</strong>.
        No olvides guardar los cambios antes de salir. -->
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <v-text-field v-model="DetalleUrgencia.Total" label="Total" prefix="$" outlined dense clearable
                      style="max-width: 200px" :rules="[rules.ruleRequired, reglaMonto]" />

                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn color="primary" text v-if="urgencia.Estado === '1'" @click="crearComentario">Enviar
                      comentario</v-btn>
                    <v-btn color="primary" :disabled="urgencia.Estado === '1'" @click="cerrarUrgencia">              
                      {{ loading ? 'Guardando...' : 'Guardar' }}</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Sin datos -->
      <v-col v-if="!urgencia.Estado" cols="12" class="text-center d-flex flex-column align-center justify-center">
        <v-icon color="grey" size="64">mdi-account-off</v-icon>
        <h3 class="mt-3 grey--text text--darken-1">
          No se encontró ninguna nota de ingreso
        </h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import formatFecha from '@/mixins/formatFecha';
import upperCase from '@/mixins/upperCase';


export default {
  mixins: [formatFecha, upperCase],
  components: {
  },
  data() {
    return {
      loading: false,
      search: 'UR',
      urgencia: {
        Id: null,
        NombreHospital: '',
        Estado: '',
        Folio: '',
        IdContrato: '',
        Titular: '',
        Paciente: '',
        MontoDisponible: 0
      },
      DetalleUrgencia: {}
    };
  },
  computed: {
    rules() {
      return this.$rules;
    },
    breadcrumbs() {
      return [
        { text: 'Inicio', disabled: true, href: '/' },
        { text: this.$route.meta.title || this.$route.name, disabled: true }
      ];
    },
    reglaMonto() {
      return v => {
        const valor = parseFloat(v);
        const max = parseFloat(this.urgencia.MontoDisponible);

        if (v === null || v === '' || isNaN(valor)) return 'Ingresa un monto válido';
        if (valor <= 0) return 'El monto debe ser mayor a 0';

        const formatoPesos = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
          minimumFractionDigits: 2
        }).format(max);

        if (valor > max) return `El monto no puede superar ${formatoPesos}`;
        return true;
      };
    }
  },
  methods: {
    crearComentario() {
      this.$swal.fire({
        title: 'Ingrese su comentario de esta urgencia',
        input: 'textarea',
        inputPlaceholder: 'Escriba aquí su texto...',
        inputAttributes: {
          'aria-label': 'Escriba aquí su texto'
        },
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        preConfirm: (texto) => {
          if (!texto) {
            this.$swal.showValidationMessage('El texto es obligatorio');
            return false;
          }
          return texto;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // Petición POST
          this.$http.post('user/comentario', {
            IdReferencia: this.urgencia.Id,
            Tema: 'DETALLE URGENCIA',
            Comentario: result.value,
          })
            .then(response => {
              console.log(response)
              this.$swal.fire('Éxito', 'Se envió correctamente', 'success');
            })
            .catch(error => {
              console.log(error)
              this.$swal.fire('Error', 'Ocurrió un problema al enviar', 'error');
            });
        }
      });
    },
    cerrarUrgencia() {
      const form = this.$refs.formUrgencia;
      if (form && !form.validate()) return;
      this.loading = true
      this.DetalleUrgencia.IdUrgencia = this.urgencia.Id
      this.$http.post(`urgencia/registradetalle`, this.DetalleUrgencia)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              //this.limpiar()
              this.urgencia.Estado = '1'
              this.$swal.fire({
                position: 'center',
                html: 'Urgencia actualizada correctamente.',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: true,
                showConfirmButton: true,
                customClass: {
                  confirmButton: 'v-btn v-btn--contained theme--light v-size--default boton-vuetify',
                  closeButton: 'v-btn boton-close'
                }
              })
            }
          }
        })
        .catch(() => {
          this.$swal.fire({
            position: 'center',
            html: `Ha ocurrido un error inesperado que ya ha sido reportado, <b>intenta mas tarde</b>.`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            //timer: 1500,
          })
        })
        .finally(() => {
          this.loading = false
        });
    },
    Buscar() {
      this.buscar()
    },
    buscar() {
      this.loading = true
      this.$http.get(`urgencia/buscaFolio?Folio=${this.search || null}`)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.urgencia = response.data
              //detalle urgencia
              this.DetalleUrgencia.Tipo = response.data.Tipo
              this.DetalleUrgencia.Factura = response.data.Factura
              this.DetalleUrgencia.Diagnostico = response.data.Diagnostico
              this.DetalleUrgencia.Total = response.data.Total
            }
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false
          //this.search =  ''
        });
    },
    limpiar() {
      this.search = ''
      this.urgencia = {}
      this.DetalleUrgencia = {}
    }
  },
};
</script>
